export const serviceIdMap = new Map();

export const ServiceIds = {
    // Old Ids
    free: "motosport-free",
    daily: "vc-fanclash-vodacom-fl-motorsport-daily-01",
    weekly: "vc-fanclash-vodacom-fl-motorsport-weekly-01",
    monthly: "vc-fanclash-vodacom-fl-motorsport-monthly-01",

    // New Ids
    dailyInternal: "vc-fanclash-quizincmotor-daily-01",
    weeklyInternal: "vc-fanclash-quizincmotor-weekly-01",
    monthlyInternal: "vc-fanclash-quizincmotor-monthly-01",
}

serviceIdMap.set(ServiceIds.free, 1);
serviceIdMap.set(ServiceIds.daily, 2);
serviceIdMap.set(ServiceIds.weekly, 3);
serviceIdMap.set(ServiceIds.monthly, 4);

serviceIdMap.set(ServiceIds.dailyInternal, 2);
serviceIdMap.set(ServiceIds.weeklyInternal, 3);
serviceIdMap.set(ServiceIds.monthlyInternal, 4);
